import { Loader } from '@infura/packages.ui/Loader'

const LegendItemSkeleton = () => (
  <div className='flex items-center gap-2'>
    <Loader className='h-4 w-4' pulse />
    <Loader className='h-4 w-20' pulse rounded />
  </div>
)

export const DailyRequestHealthSkeleton = () => {
  return (
    <div className='mt-4'>
      <div className='h-30 w-30 relative mx-auto flex items-center justify-center'>
        <Loader className='h-30 w-30 absolute' pulse rounded />
        <div className='bg-background-default absolute h-24 w-24 rounded-full'></div>
        <div className='flex flex-col items-center'>
          <Loader className='h-7 w-16' pulse rounded />
          <Loader className='mt-1 h-5 w-11' pulse rounded />
        </div>
      </div>
      <div className='border-border-muted mx-auto mt-4 flex max-w-[312px] flex-wrap gap-8 rounded-[5px] border px-4 py-2'>
        {Array(2)
          .fill(1)
          .map((item, index) => (
            <LegendItemSkeleton key={`legenditem-${index}`} />
          ))}
      </div>
    </div>
  )
}
